<!--
 * @Name: editPassword
 * @Description: 修改密码
 * @Author: xiadongxue
 * @Date: 2021-10-26 18:33:38
 * @Editors: xiadongxue
-->
<template>
<div class="user-edit-wrap">
    <el-dialog
        v-loading="loading"
        title="修改密码"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @close="close"
        width="600px">
        <el-form
            label-width="170px"
            ref="form"
            :model="form"
            :rules="passwordRules">
            <el-form-item
                prop="oldPwd"
                label="旧密码">
                <el-input
                    type="password"
                    show-password
                    v-model="form.oldPwd"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="newPwd"
                label="新密码">
                <pwd-warn :edit="true" :pwd.sync="form.newPwd" :show="visible"/>
            </el-form-item>
            <el-form-item
                prop="confirmPwd"
                label="确认密码">
                <el-input
                    type="password"
                    show-password
                    v-model="form.confirmPwd"
                    size="small" />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="close"
                size="small">取消</el-button>
            <el-button
                size="small"
                type="danger"
                @click="toSubmit">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    editPwd
} from '@/api'
import PwdWarn from '@/components/PwdWarn'
export default {
    name: 'editPassword',
    props: {
        //弹窗展示
        show: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PwdWarn
    },
    data() {
        return {
            loading: false,
            visible: false,
            form: {
                oldPwd: '',
                newPwd: '',
                confirmPwd: ''
            },
            passwordRules: {
                oldPwd: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }],
                newPwd: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }, {
                    pattern: /(?=.{8,})/,
                    message: "请输入至少8个字符",
                    trigger: 'submit'
                }, {
                    pattern: /(?=.*[A-Z]{1,})(?=.*[a-z]{1,})/,
                    message: "请输入包含大写与小写字母",
                    trigger: 'submit'
                }, {
                    pattern: /(?=.*\d)/,
                    message: "请输入至少1个数字",
                    trigger: 'submit'
                }, {
                    pattern: /^[^\s]*$/,
                    message: "不能输入空格",
                    trigger: 'submit'
                }],
                confirmPwd: [{
                    required: true,
                    message: "请输入"
                }, {
                    validator: (rule, value, callback) => {
                        if (value !== this.form.newPwd) {
                            callback(new Error('密码不一致'));
                        } else {
                            callback();
                        }
                    }
                }]
            }
        }
    },
    created() {
        this.visible = this.show
    },
    methods: {
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave();
                } else {
                    return false;
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true
                let {
                    code
                } = await editPwd({
                    ...this.form
                })
                if (code === 0) {
                    this.$message.success('修改成功')
                    this.close()
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //移除表单项校验结果
        close() {
            this.$emit('update:show', false)
            this.form = {
                oldPwd: '',
                newPwd: '',
                confirmPwd: ''
            }
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
        }
    },
    watch: {
        show(val) {
            if(this.visible != val) {
                this.visible = val
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.user-edit-wrap {

    .el-input,
    .el-textarea {
        width: 300px;
    }
}
</style>
